module.exports = __webpack_public_path__ + "img/111035.47c86237.png";